import React, {useReducer, useEffect} from 'react'
import styled, {createGlobalStyle, ThemeProvider} from 'styled-components'
import { MDXProvider } from "@mdx-js/react"
import {TableBody, TableHead, } from '@material-ui/core'

import Table from '../../mdxStyles/Table'
import TableCell from '../../mdxStyles/TableCell'
import TableRow from '../../mdxStyles/TableRow'


import { StateContext } from '../../utils/context'
import { initialState, reducer} from '../../utils/reducer'

import Header from '../GlobalHeader'
import Footer from '../GlobalFooter'
import MainColumnText from '../../atoms/MainColumnText'

import {colors} from '../../utils/styles'

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    transition: all 0.3s;
  }
`

export default ({ children, location }) => {
  const [state, dispatch] = useReducer(reducer, initialState)
  
  useEffect(() => {
    dispatch({type: 'ResizeWindow', payload: window.innerWidth})
    window.addEventListener('resize', () => {
      dispatch({type: 'ResizeWindow', payload: window.innerWidth})
    })
  }, [])

  useEffect(() => {
    if (location) dispatch({type: 'SetGlobalLocation', payload: location})
  }, [])
  
  return (
    <StateContext.Provider value={{state: state, dispatch: dispatch}}>
      <ThemeProvider theme={colors}>
        <MDXProvider components={{
          table: Table,
          tr: TableRow,
          td: TableCell,
          th: TableCell,
          tbody: TableBody,
          thead: TableHead,
        }}>
          <GlobalStyle/>
          <Header/>
          <MainColumnText/>
          <BodyContainer>
            <Main>
              { children }
            </Main>
            <Footer/>
          </BodyContainer>
        </MDXProvider>
      </ThemeProvider>
    </StateContext.Provider>
  )
}

const BodyContainer = styled.div`
  padding: 0;
  margin: 0;
`
const Main = styled.div`
  padding: 0;
  margin: 0;
`